// Browser-safe Klaviyo signup for the product-development page.
// The section keeps a normal Shopify customer form as a no-JS and no-list-ID
// fallback. This intercepts only when both public Klaviyo identifiers are set.
// Never place a private Klaviyo key in theme code.
document.addEventListener('submit', async (event) => {
  const root = event.target && event.target.closest && event.target.closest('[data-klaviyo-signup-root]');
  if (!root) return;

  const companyId = (root.dataset.companyId || '').trim();
  const listId = (root.dataset.listId || '').trim();
  if (!companyId || !listId) return;

  event.preventDefault();
  const form = event.target;
  const emailInput = form.querySelector('input[name="contact[email]"]');
  const email = ((emailInput || {}).value || '').trim();
  const success = root.querySelector('[data-klaviyo-signup-success]');
  const error = root.querySelector('[data-klaviyo-signup-error]');
  const submit = form.querySelector('[type="submit"]');

  if (success) success.hidden = true;
  if (error) error.hidden = true;
  if (!email || !email.includes('@')) {
    if (emailInput && emailInput.reportValidity) emailInput.reportValidity();
    if (error) error.hidden = false;
    return;
  }

  const customSource = root.dataset.customSource || 'Agadors coming soon page';
  const payload = {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: customSource,
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email,
              subscriptions: {
                email: { marketing: { consent: 'SUBSCRIBED' } }
              },
              properties: {
                'Signup Source': customSource,
                'Signup Page URL': window.location.href,
                'Product Interests': ['Hackamore Bridle', 'Pink Bit', 'Mystery Rubber']
              }
            }
          }
        }
      },
      relationships: {
        list: { data: { type: 'list', id: listId } }
      }
    }
  };

  if (submit) submit.disabled = true;
  form.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        Accept: 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
        revision: '2026-07-15'
      },
      body: JSON.stringify(payload)
    });

    if (response.status === 202) {
      form.hidden = true;
      if (success) success.hidden = false;
    } else if (error) {
      error.hidden = false;
    }
  } catch (_) {
    if (error) error.hidden = false;
  } finally {
    form.removeAttribute('aria-busy');
    if (submit) submit.disabled = false;
  }
});
